import {
  Button,
  Center,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Stack,
} from "@chakra-ui/react";
import { useAtom } from "jotai";
import { errorContentState } from "./use-error-state";

export const ErrorModal = () => {
  const [errorModal, setErrorModal] = useAtom(errorContentState);

  return (
    <Modal
      isCentered
      onClose={() => setErrorModal({ ...errorModal, isOpen: false })}
      isOpen={errorModal.isOpen}
      scrollBehavior="outside"
      motionPreset="slideInBottom"
    >
      <ModalOverlay height="100vh" />
      <ModalContent
        position={{
          base: "fixed",
          md: "relative",
        }}
        bottom={{ base: "0px" }}
        mb="0"
        p="4"
        borderRadius={{
          base: "1.75rem 1.75rem 0px 0px",
          md: "md",
        }}
        maxW={{ base: "2xl", lg: "3xl" }}
      >
        <ModalHeader
          textAlign="center"
          fontSize="3xl"
          {...errorModal?.headerSx}
        >
          {errorModal.title}
        </ModalHeader>
        {errorModal.content && (
          <Center textAlign="center" {...errorModal?.contentSx}>
            {errorModal.content}
          </Center>
        )}
        <ModalCloseButton
          outline="none"
          _focus={{ outline: "none" }}
          onClick={() => setErrorModal({ ...errorModal, isOpen: false })}
        />
        <ModalBody>
          {errorModal.children}
          <Stack
            textAlign="center"
            alignItems={{
              base: "center",
              lg: "center",
            }}
            justifyContent={{
              lg: "space-around",
            }}
            flexDirection={{
              base: "column",
              lg: "row",
            }}
            mt="2"
            spacing={{ base: "4", lg: "6" }}
          >
            {errorModal.actions && errorModal.actions}
            <Button
              type="button"
              aria-label="Close"
              variant="link"
              onClick={() => setErrorModal({ ...errorModal, isOpen: false })}
              {...errorModal.closeButton?.props}
            >
              {errorModal.closeButton?.label || "Close"}
            </Button>
          </Stack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
